import React from "react";
import { Tooltip } from "@mui/material";
import { Download, Loader2, MoreHorizontal, Trash2 } from "lucide-react";
import { Button } from "../../ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../../ui/popover";

/** Download and overflow-menu buttons at the end of the filter bar. */
const RequestListActions = ({ exporting, disabled, onExport, canMutate, onDeleteByDate }) => (
  <div className="ml-auto flex items-center gap-2">
    <Tooltip title="Download Excel">
      <span>
        <Button
          type="button"
          variant="outline"
          className="h-9 w-9 p-0 shrink-0"
          aria-label="Download Excel"
          disabled={exporting || disabled}
          onClick={onExport}
        >
          {exporting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
        </Button>
      </span>
    </Tooltip>
    {canMutate && (
      <Popover>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" className="h-9 w-9 p-0 shrink-0" aria-label="More actions">
            <MoreHorizontal className="w-4 h-4" />
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-56 p-1">
          <button
            type="button"
            onClick={onDeleteByDate}
            className="flex w-full items-center gap-2 rounded-md px-2.5 py-2 text-left text-sm text-red-600 hover:bg-red-50"
          >
            <Trash2 className="h-4 w-4" />
            Delete requests by date
          </button>
        </PopoverContent>
      </Popover>
    )}
  </div>
);

export default RequestListActions;
